module.exports = __webpack_public_path__ + "img/brand-toyota.5f72dcb2.png";